











































import {Component, Vue} from 'vue-property-decorator';
import Carousel from '@/components/Carousel.vue';
import ItemTile from '@/components/ItemTile.vue';
import requireAll from '../helpers/requireAll';

@Component({
	components: {
		Carousel,
		ItemTile,
	},
})
export default class Home extends Vue {
	private carouselItems = requireAll(require.context('../assets/home/', false, /\.jpg$/));
}
